import { assign } from 'xstate';
import { Context } from '../filtersMachine';

const removeFilter = assign<Context, any>({
    filters: (ctx, evt) => ctx.filters.filter((filter) => filter.id !== evt.payload.id),
});

export default removeFilter;
